import { useAgentContext } from '../_providers/UserAgentProvider';
import { useState, useEffect } from 'react';

export const useIsMobile = () => {
  const userAgent = useAgentContext();

  // Use the user agent to set the initial state
  const initialIsMobile = userAgent?.device?.type === 'mobile';
  const [isMobile, setIsMobile] = useState(initialIsMobile);

  useEffect(() => {
    if (!userAgent) {
      throw new Error(
        'useIsMobile must be used within a UserAgentContext.Provider'
      );
    }

    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
    };

    if (typeof window !== 'undefined') {
      checkMobile(); // Check immediately on mount
      window.addEventListener('resize', checkMobile);

      // Cleanup event listener on component unmount
      return () => window.removeEventListener('resize', checkMobile);
    }
  }, [userAgent]);

  return isMobile;
};
